import React, { useEffect, useState } from "react";

import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const CustomTextField = ({
  name,
  label,
  value,
  onChange,
  autoComplete,
  fullWidth = false,
  required = true,
  disabled = false,
  error,
  helperText,
}) => (
  <TextField
    name={name}
    label={label}
    value={value}
    onChange={onChange}
    fullWidth={fullWidth}
    margin="normal"
    required={required}
    disabled={disabled}
    autoComplete={autoComplete}
    helperText={helperText}
    error={error}
    InputProps={{
      endAdornment: <InputAdornment position="end"></InputAdornment>,
    }}
  />
);

export const PasswordField = ({
  name,
  label,
  value,
  onChange,
  showPassword,
  toggleShowPassword,
  error,
  helperText,
  autoComplete,
}) => (
  <TextField
    name={name}
    label={label}
    type={showPassword ? "text" : "password"}
    value={value}
    onChange={onChange}
    fullWidth
    margin="normal"
    required
    error={error}
    autoComplete={autoComplete}
    helperText={helperText}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={toggleShowPassword} edge="end">
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
);

export const CustomRoleSelectField = ({
  name,
  label,
  values,
  onChange,
  options,
  error,
  helperText,
  required = true,
}) => {
  const [entries, setEntries] = useState(values);

  useEffect(() => {
    setEntries(values);
  }, [values]);

  const handleUpdateRoles = (event, index) => {
    const newEntries = [...entries];
    newEntries[index].role_name = event.target.value;
    setEntries(newEntries);
    onChange({ target: { name, value: newEntries } });
  };

  return (
    <>
      {entries.map((value, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center" }}>
          <FormControl fullWidth margin="normal" required={required} style={{ minWidth: "50%" }}>
            <InputLabel shrink>{label}</InputLabel>
            <Select
              value={value.role_name}
              label={label}
              displayEmpty
              onChange={(event) => handleUpdateRoles(event, index)}
            >
              {options.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      ))}
      <div>{error && helperText && <Typography color="error">{helperText}</Typography>}</div>
    </>
  );
};
